// removed by extract-text-webpack-plugin
module.exports = {"DetailsPayment":"DetailsPayment__DetailsPayment___3kgWz","DetailsPayment__thDtoAdd":"DetailsPayment__DetailsPayment__thDtoAdd___rwFf5","DetailsPayment__tdDtoAdd":"DetailsPayment__DetailsPayment__tdDtoAdd___2vsGN","DetailsPayment__thComment":"DetailsPayment__DetailsPayment__thComment___E-_Fd","DetailsPayment__thStatus":"DetailsPayment__DetailsPayment__thStatus___3dqAQ","DetailsPayment__tdComment":"DetailsPayment__DetailsPayment__tdComment___3SA6R"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/treasury/payment-partners/components/DetailsPayment.css
// module id = 1006
// module chunks = 0